import "../../../App.css";
import { ProcessorMain } from "./Process/ProcessorMain";
import { RequesterMain } from "./Setup/RequesterMain";

// MRF Components

function MRF({ user, userAccess, isHideSideMenu }) {

  console.warn("Define which people can have access on it", userAccess);

  return (
    <>
      <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
        <div className="LeftSpace"></div>
        <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
          <div className="EmployeesTabInfo shadow-xl">
            <div className="employeesTab-header">
              <div className='sub-title row'>
                <span style={{ padding: "0 5px 0 0", color: "#b0b0b0" }}>{"Talent Management >"} </span>
                <span style={{ borderBottom: "1px solid black" }}>{"MRF"}</span>
              </div>
              <div className='row' style={{ justifyContent: "space-between", alignItems: "center" }}>
                <h3>MRF</h3>
              </div>
            </div>

            <div className='p-4 space-y-4'>

              {userAccess?.isRequester === true  && (
                <>
                  {/* requester main section here */}
                  <RequesterMain />
                </>
              )}

              {userAccess?.isProcessor === true && (
                <>
                  <ProcessorMain />
                </>
              )}

            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default MRF